import $ from 'jquery';
import ajax from '../services/ajax';

class ForgotPassword {
    constructor() {
        this.scopedSubmitListener = this.submitListener.bind(this);
    }

    showForgotPasswordSuccess() {
        this.$forgotPasswordCol.html(`
            <h1>Please check your email to reset your password.</h1>
        `);
    }

    showForgotPasswordError(errMsg) {
        const errorMessage = this.formatErrorResponse(errMsg);
        this.$errorMsgContainer.html(`
            ${errorMessage}
        `);
    }

    formatErrorResponse(err) {
        let response;
        try {
            response = JSON.parse(err[0].responseText).message;
        } catch (error) {
            response = 'unknown error occurred';
        }
        return response;
    }

    submitListener(e) {
        e.preventDefault();
        return this.forgotPassword().then(() => {
            this.showForgotPasswordSuccess();
        }).catch((err)=> {
            this.showForgotPasswordError(err);
        });
    }

    forgotPassword() {
        const email = this.$forgotPasswordInput.val();
        return ajax(this.forgotPasswordUrl, {
            method: this.forgotPasswordMethod,
            data: {email}
        });
    }

    off() {
        this.$form.off('submit', this.scopedSubmitListener);
    }

    on() {
        const $form = $('.js-forgot-password-form');
        this.$form = $form;
        this.$errorMsgContainer = $('.error-messages');
        this.$forgotPasswordCol = $('.js-forgot-password-column');
        this.forgotPasswordUrl = $form.attr('action');
        this.forgotPasswordMethod = $form.attr('method');
        this.$forgotPasswordInput = $('.js-forgot-password-input');
        this.$forgotPasswordButton = $('.js-forgot-password-button');
        this.$form.on('submit', this.scopedSubmitListener);
    }
}

export default new ForgotPassword();

